/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

export const ACCOUNT_EMAIL_CHANGE_STATE_TOPIC_PREFIX = '/topic/account-email-change-state/';

export const ACCOUNT_RECOVERY_STATE_TOPIC_PREFIX = '/topic/account-recovery-state/';

export const EMPLOYEE_REGISTRATION_STATE_TOPIC_PREFIX = '/topic/employee-registration-state/';

export const FLEX_SERVICE_WORKER_REGISTRATION_STATE_TOPIC_PREFIX = '/topic/flexservice-worker-registration-state/';
